import { WeGoConfig } from './../config';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GeoLocationService {

  constructor(private authService: AuthService, private http: Http) { }

  public GetFormatedAddressFromLatlng(latlng: string, language: string): Observable<any> {

    let reqUrl = WeGoConfig.HERE_MAP_REVERSE_GEOCODE_URL + '?' +
      'at=' + latlng + ',' + WeGoConfig.HERE_MAP_LOC_RADIUS +   // The search text which is the basis of the query
      '&lang=' + language.toLowerCase() +  // The upper limit the for number of suggestions to be included in the response. Default is set to 5.
      '&apiKey=' + WeGoConfig.HERE_MAP_API_KEY;
    ;
    return this.http.get(reqUrl)
      .map(this.authService.HandleAPIResponse).map((res: any) => {
            var label = '';
            if (res && res.items && res.items.length > 0) {
                var firstItem = res.items[0];
                if (firstItem.title) {
                    label = firstItem.title;
                } else if (firstItem.address && firstItem.address.label) {
                    label = firstItem.address.label;
                }

                return {
                    Response: {
                        View: [
                            {
                                Result: [
                                    {
                                        MatchLevel: 'houseNumber',
                                        Location: {
                                            Address: {
                                                Label: label
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                };
            }

            // Fallback if no items
            return {
                Response: {
                    View: []
                }
            };
        })
        .catch(this.authService.HandleAPIError);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/models/geolocation.service.ts